import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import BankIcon from "../../../components/Icons/BankIcon";
import EditIcon from "../../../components/Icons/EditIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import ViewDocumentModal from "../ViewDocumentModal";
import MainHeading from "../../../components/comman/MainHeading";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import moment from "moment";

export default function CompanyDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const [companyDetail, setCompanyDetail] = useState({});
  const [modal, setModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const toggleModal = () => {
    setModal(!modal);
  };

  const GetCompayDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_company + `?companyId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setCompanyDetail(response?.data?.company?.[0] || {});
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  useEffect(() => {
    GetCompayDetail();
  }, []);

  const companyLogo = companyDetail?.documents?.find(
    (item) => item?.name === "Company_Logo"
  )?.url;

  const totalDocumentsCount = companyDetail?.documents?.length || 0;

  return (
    <>
      {isLoading && <BgBlurLoader />}
      <div className="content container-fluid pb-5">
        {/* Main Header with Actions */}
        <MainHeading
          title="Company Detail"
          showBackButton={true}
          buttonText="Edit Company"
          buttonIcon={<EditIcon />}
          clickHandler={() =>
            navigate(RoutesLink.add_company, {
              state: { EditData: companyDetail },
            })
          }
        />

        {/* Master Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            {/* Top Identity Strip */}
            <div
              className="d-flex align-items-start justify-content-between flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-3">
                {companyLogo ? (
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0 overflow-hidden border"
                    style={{
                      width: "56px",
                      height: "56px",
                      background: "#ffffff",
                      borderColor: "#e2e8f0",
                      padding: "4px",
                    }}
                  >
                    <img
                      src={companyLogo}
                      alt={companyDetail?.name || "Company Logo"}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ) : (
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-3 p-2.5 flex-shrink-0"
                    style={{
                      background: "#eff6ff",
                      color: "#2563eb",
                      width: "52px",
                      height: "52px",
                      fontSize: "24px",
                    }}
                  >
                    🏢
                  </div>
                )}

                <div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h3
                      className="mb-0 fw-bold text-dark"
                      style={{ letterSpacing: "-0.02em", fontSize: "1.35rem" }}
                    >
                      {companyDetail?.name || "--"}
                    </h3>
                    {companyDetail?.shortName && (
                      <span
                        className="badge rounded-pill px-2.5 py-1 fw-semibold d-inline-flex align-items-center gap-1"
                        style={{
                          fontSize: "12px",
                          background: "#eff6ff",
                          color: "#1d4ed8",
                          border: "1px solid #bfdbfe",
                        }}
                      >
                        <span>🏛️</span>
                        <span>{companyDetail.shortName}</span>
                      </span>
                    )}
                    <span
                      className="badge rounded-pill px-2.5 py-1 fw-semibold bg-success-subtle text-success border border-success-subtle"
                      style={{ fontSize: "12px" }}
                    >
                      Active Entity
                    </span>
                  </div>

                  <div className="text-secondary small mt-1 d-flex align-items-center gap-2 flex-wrap">
                    {companyDetail?.email && (
                      <>
                        <span className="d-inline-flex align-items-center gap-1">
                          <span>✉️</span>
                          <span>{companyDetail.email}</span>
                        </span>
                        <span>•</span>
                      </>
                    )}
                    {companyDetail?.phone && (
                      <>
                        <span className="d-inline-flex align-items-center gap-1">
                          <span>📞</span>
                          <span>{companyDetail.phone}</span>
                        </span>
                        <span>•</span>
                      </>
                    )}
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📍</span>
                      <span>
                        {companyDetail?.city
                          ? `${companyDetail.city}${
                              companyDetail?.state ? `, ${companyDetail.state}` : ""
                            }`
                          : companyDetail?.address || "Registered Organization"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              {/* Quick Quantitative Stats */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "140px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    GSTIN
                  </div>
                  <div
                    className="fw-bold text-dark text-truncate"
                    style={{
                      fontSize: "15px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                      letterSpacing: "0.02em",
                    }}
                    title={companyDetail?.gst}
                  >
                    {companyDetail?.gst || "--"}
                  </div>
                </div>

                {companyDetail?.pan && (
                  <div
                    className="px-3.5 py-2 rounded-2 text-center"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      minWidth: "120px",
                    }}
                  >
                    <div
                      className="text-secondary text-uppercase"
                      style={{
                        fontSize: "10px",
                        fontWeight: 700,
                        letterSpacing: "0.05em",
                      }}
                    >
                      PAN
                    </div>
                    <div
                      className="fw-bold text-dark text-truncate"
                      style={{
                        fontSize: "15px",
                        lineHeight: "1.2",
                        marginTop: "2px",
                        letterSpacing: "0.02em",
                      }}
                      title={companyDetail.pan}
                    >
                      {companyDetail.pan}
                    </div>
                  </div>
                )}

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "105px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Documents
                  </div>
                  <div
                    className="fw-bold text-primary"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {totalDocumentsCount}
                  </div>
                </div>
              </div>
            </div>

            {/* Key Information Grid */}
            <div className="row g-3 pt-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Company Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={companyDetail?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {companyDetail?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Legal Business Entity
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Short Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={companyDetail?.shortName}
                    style={{ fontSize: "13.5px" }}
                  >
                    {companyDetail?.shortName || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Corporate Acronym
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Primary Email
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={companyDetail?.email}
                    style={{ fontSize: "13.5px" }}
                  >
                    {companyDetail?.email || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Official Correspondence
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Secondary Email
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={companyDetail?.secondaryEmail}
                    style={{ fontSize: "13.5px" }}
                  >
                    {companyDetail?.secondaryEmail || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Alternative Email
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Primary Contact
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={companyDetail?.phone}
                    style={{ fontSize: "13.5px" }}
                  >
                    {companyDetail?.phone || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Head Office Phone
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Secondary Contact
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={companyDetail?.secondaryPhone}
                    style={{ fontSize: "13.5px" }}
                  >
                    {companyDetail?.secondaryPhone || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Support / Secondary
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    GST Number
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={companyDetail?.gst}
                    style={{ fontSize: "13.5px" }}
                  >
                    {companyDetail?.gst || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Tax Identification
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    PAN Number
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={companyDetail?.pan}
                    style={{ fontSize: "13.5px" }}
                  >
                    {companyDetail?.pan || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Permanent Account No.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bank Details Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div
            className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
            style={{ borderColor: "#f1f5f9" }}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                style={{ background: "#f1f5f9", color: "#475569" }}
              >
                <BankIcon />
              </div>
              <h5
                className="mb-0 fw-bold text-dark"
                style={{ fontSize: "15px" }}
              >
                Banking & Settlement Credentials
              </h5>
            </div>
            <span
              className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
              style={{ fontSize: "12px", fontWeight: 600 }}
            >
              {companyDetail?.bankName || "Official Bank Account"}
            </span>
          </div>

          <div className="card-body p-4">
            <div className="row g-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.04em",
                    }}
                  >
                    Account Holder
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={companyDetail?.accountHolder}
                    style={{ fontSize: "14px" }}
                  >
                    {companyDetail?.accountHolder || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Beneficiary Name
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.04em",
                    }}
                  >
                    Account Number
                  </div>
                  <div
                    className="fw-bold text-dark text-truncate"
                    title={companyDetail?.accountNumber}
                    style={{ fontSize: "14px", letterSpacing: "0.02em" }}
                  >
                    {companyDetail?.accountNumber || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Bank Account No.
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.04em",
                    }}
                  >
                    IFSC Code
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={companyDetail?.IFSC_code}
                    style={{ fontSize: "14px" }}
                  >
                    {companyDetail?.IFSC_code || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    RTGS / NEFT Code
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.04em",
                    }}
                  >
                    Bank & Branch
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={
                      companyDetail?.bankName
                        ? `${companyDetail.bankName}${
                            companyDetail.branchName
                              ? ` - ${companyDetail.branchName}`
                              : ""
                          }`
                        : companyDetail?.branchName
                    }
                    style={{ fontSize: "14px" }}
                  >
                    {companyDetail?.bankName
                      ? `${companyDetail.bankName}${
                          companyDetail.branchName
                            ? ` (${companyDetail.branchName})`
                            : ""
                        }`
                      : companyDetail?.branchName || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Operating Branch
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Documents & Registered Office Address (2-Column Grid) */}
        <div className="row g-4 mb-4">
          {/* Documents Card */}
          <div className="col-12 col-lg-5">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span style={{ fontSize: "16px" }}>📄</span>
                  <h5
                    className="mb-0 fw-bold"
                    style={{ fontSize: "14.5px", color: "#0f172a" }}
                  >
                    Corporate Documents
                  </h5>
                </div>
                <span
                  className="badge bg-light text-secondary border px-2.5 py-1 rounded-pill"
                  style={{ fontSize: "11px", fontWeight: 600 }}
                >
                  {totalDocumentsCount}
                </span>
              </div>

              <div className="card-body p-4">
                {companyDetail?.documents?.length > 0 ? (
                  <div className="d-flex flex-column gap-2.5">
                    {companyDetail?.documents?.map((doc, index) => {
                      const isLogo = doc?.name === "Company_Logo";
                      const updatedDate = doc?.updatedAt
                        ? moment(doc.updatedAt).format("DD MMM YYYY | h:mm a")
                        : "";
                      return (
                        <div
                          key={index}
                          onClick={() => handleDocumentClick(doc)}
                          className="p-3 rounded-2 d-flex align-items-center justify-content-between cursor-pointer"
                          style={{
                            background: "#f8fafc",
                            border: "1px solid #e2e8f0",
                            cursor: "pointer",
                            transition: "all 0.15s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f1f5f9";
                            e.currentTarget.style.borderColor = "#cbd5e1";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#f8fafc";
                            e.currentTarget.style.borderColor = "#e2e8f0";
                          }}
                        >
                          <div className="d-flex align-items-center gap-2.5 text-truncate me-2">
                            <div
                              className="rounded-2 p-1.5 d-flex align-items-center justify-content-center flex-shrink-0"
                              style={{
                                background: isLogo ? "#fef3c7" : "#eff6ff",
                                color: isLogo ? "#d97706" : "#2563eb",
                              }}
                            >
                              <DocumentIcon />
                            </div>
                            <div className="text-truncate">
                              <span
                                className="fw-semibold text-dark text-truncate d-block"
                                style={{ fontSize: "13px" }}
                                title={doc?.name || "Document"}
                              >
                                {isLogo
                                  ? "Company Logo"
                                  : doc?.name || `Document #${index + 1}`}
                              </span>
                              {isLogo && (
                                <span
                                  className="badge rounded-pill"
                                  style={{
                                    fontSize: "10px",
                                    background: "#fef3c7",
                                    color: "#b45309",
                                  }}
                                >
                                  Official Logo
                                </span>
                              )}
                            </div>
                          </div>
                          <div
                            className="text-secondary small flex-shrink-0"
                            style={{ fontSize: "11px" }}
                          >
                            {updatedDate || "View Document"}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    className="p-4 rounded-2 text-center text-muted"
                    style={{ border: "2px dashed #e2e8f0" }}
                  >
                    <div style={{ fontSize: "24px", opacity: 0.5 }}>📁</div>
                    <div className="small mt-1 fw-medium">
                      No Documents Uploaded
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Registered Office & Location Card */}
          <div className="col-12 col-lg-7">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center gap-2 border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <span style={{ fontSize: "16px" }}>📍</span>
                <h5
                  className="mb-0 fw-bold"
                  style={{ fontSize: "14.5px", color: "#0f172a" }}
                >
                  Registered Office & Location
                </h5>
              </div>
              <div className="card-body p-4">
                <div
                  className="p-3.5 rounded-2 mb-3"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.04em",
                    }}
                  >
                    Registered Headquarters Address
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px", lineHeight: "1.5" }}
                  >
                    {companyDetail?.address || "--"}
                  </div>
                  {(companyDetail?.city ||
                    companyDetail?.state ||
                    companyDetail?.pinCode) && (
                    <div
                      className="text-secondary small mt-1.5"
                      style={{ fontSize: "12px" }}
                    >
                      {[
                        companyDetail?.city,
                        companyDetail?.state,
                        companyDetail?.pinCode,
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    </div>
                  )}
                </div>

                <div className="row g-2.5">
                  <div className="col-12 col-sm-6">
                    <div
                      className="p-2.5 rounded-2 h-100"
                      style={{
                        background: "#ffffff",
                        border: "1px solid #e2e8f0",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-0.5"
                        style={{ fontSize: "10.5px", fontWeight: 700 }}
                      >
                        Primary Email
                      </div>
                      <div
                        className="fw-semibold text-dark text-truncate"
                        style={{ fontSize: "13px" }}
                        title={companyDetail?.email}
                      >
                        {companyDetail?.email || "--"}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6">
                    <div
                      className="p-2.5 rounded-2 h-100"
                      style={{
                        background: "#ffffff",
                        border: "1px solid #e2e8f0",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-0.5"
                        style={{ fontSize: "10.5px", fontWeight: 700 }}
                      >
                        Secondary Email
                      </div>
                      <div
                        className="fw-semibold text-dark text-truncate"
                        style={{ fontSize: "13px" }}
                        title={companyDetail?.secondaryEmail}
                      >
                        {companyDetail?.secondaryEmail || "--"}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6">
                    <div
                      className="p-2.5 rounded-2 h-100"
                      style={{
                        background: "#ffffff",
                        border: "1px solid #e2e8f0",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-0.5"
                        style={{ fontSize: "10.5px", fontWeight: 700 }}
                      >
                        Primary Phone
                      </div>
                      <div
                        className="fw-semibold text-dark text-truncate"
                        style={{ fontSize: "13px" }}
                        title={companyDetail?.phone}
                      >
                        {companyDetail?.phone || "--"}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6">
                    <div
                      className="p-2.5 rounded-2 h-100"
                      style={{
                        background: "#ffffff",
                        border: "1px solid #e2e8f0",
                      }}
                    >
                      <div
                        className="text-muted text-uppercase mb-0.5"
                        style={{ fontSize: "10.5px", fontWeight: 700 }}
                      >
                        Secondary Phone
                      </div>
                      <div
                        className="fw-semibold text-dark text-truncate"
                        style={{ fontSize: "13px" }}
                        title={companyDetail?.secondaryPhone}
                      >
                        {companyDetail?.secondaryPhone || "--"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Terms & Conditions Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div
            className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
            style={{ borderColor: "#f1f5f9" }}
          >
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: "16px" }}>📜</span>
              <h5
                className="mb-0 fw-bold text-dark"
                style={{ fontSize: "15px" }}
              >
                Terms & Conditions
              </h5>
            </div>
            <span
              className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
              style={{ fontSize: "12px", fontWeight: 600 }}
            >
              Master Contract Terms
            </span>
          </div>

          <div className="card-body p-4">
            {companyDetail?.tANDc ? (
              <div
                className="border rounded-2 p-2"
                style={{ background: "#ffffff" }}
              >
                <CKEditor
                  editor={ClassicEditor}
                  data={companyDetail.tANDc}
                  disabled
                  config={{
                    toolbar: [
                      "heading",
                      "|",
                      "bold",
                      "italic",
                      "underline",
                      "strikethrough",
                      "|",
                      "fontColor",
                      "fontBackgroundColor",
                      "fontFamily",
                      "fontSize",
                      "alignment",
                      "|",
                      "link",
                      "bulletedList",
                      "numberedList",
                      "blockQuote",
                      "undo",
                      "redo",
                    ],
                    image: {
                      toolbar: [
                        "imageStyle:alignLeft",
                        "imageStyle:alignCenter",
                        "imageStyle:alignRight",
                        "|",
                        "imageTextAlternative",
                      ],
                    },
                    height: "400px",
                  }}
                />
              </div>
            ) : (
              <div
                className="p-4 rounded-2 text-center text-muted"
                style={{ border: "2px dashed #e2e8f0" }}
              >
                <div style={{ fontSize: "24px", opacity: 0.5 }}>📝</div>
                <div className="small mt-1 fw-medium">
                  No Terms & Conditions Provided
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
